/**
 * digitvision
 *
 * @category  digitvision
 * @package   Shopware\Plugins\DvsnFormBuilder
 * @copyright (c) 2026 digitvision
 */

import template from './dvsn-form-builder-side-menu.html.twig';
import './dvsn-form-builder-side-menu.scss';

const { Component } = Shopware;

Component.register('dvsn-form-builder-side-menu', {
    template,

    props: {
        active: {
            type: String,
            required: true
        },
        isLoading: {
            type: Boolean,
            required: true
        }
    },

    data() {
        return {
            menu: [
                {
                    label: this.$t('dvsn-form-builder.side-menu.menu.label'),
                    children:
                        [
                            { id: 'form', route: 'dvsn.form.builder.form.list', label: this.$t('dvsn-form-builder.side-menu.menu.children.form') },
                            { id: 'submission', route: 'dvsn.form.builder.submission.list', label: this.$t('dvsn-form-builder.side-menu.menu.children.submission') }
                        ]
                }
            ]
        };
    },
});
